import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Add inline styles for menu visibility
const menuStyles = `
.main-menu__list, .main-menu__list * {
  color: #000 !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.main-menu__list a, .main-menu__list a * {
  color: #000 !important;
  font-size: 16px !important;
}
.sub-menu a {
  color: #fff !important;
}
.dropdown-icon {
  color: #fff !important;
}
`;

const MenuItems = (props) => {
    const { parentMenu, secondParentMenu, activeMenu, handleMobileMenu } = props;
    const [isCoursesDropdown, setIsCoursesDropdown] = useState(false);
    const [isPagesDropdown, setIsPagesDropdown] = useState(false);
    const [isAboutDropdown, setIsAboutDropdown] = useState(false); // State for About dropdown
    // Define isMobile flag (adjust breakpoint as needed)
    const isMobile = window.innerWidth < 768;

    return (
        <React.Fragment>
            <style>{menuStyles}</style>
            <li className={parentMenu === 'about' ? 'dropdown current-menu-item' : 'dropdown'} style={{ display: 'block', padding: '10px 0' }}>
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    setIsAboutDropdown(!isAboutDropdown);
                    setIsCoursesDropdown(false); // Close Courses dropdown
                    setIsPagesDropdown(false);  // Close Pages dropdown
                }} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px', visibility: 'visible', opacity: 1, fontWeight: 'bold', textDecoration: 'none', lineHeight: '1.5' }}>
                    About
                    {isMobile && (
                        <i className={`fa ${isAboutDropdown ? 'fa-angle-up' : 'fa-angle-down'} dropdown-icon`} style={{ marginLeft: '35px', color: '#fff', fontSize: '16px' }}></i>
                    )}
                </Link>
                <ul className="sub-menu" style={{ display: isAboutDropdown ? 'block' : 'none', backgroundColor: '#3a2a1f', listStyle: 'none', padding: '0', margin: '0' }}>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/about" onClick={handleMobileMenu} className={activeMenu === "/about" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>About Us</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/our-management" onClick={handleMobileMenu} className={activeMenu === "/management" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Our-Management</Link>
                    </li>
                </ul>
            </li>
            <li className={parentMenu === 'Services' ? ' current-menu-item' : ''} style={{ padding: '10px 0' }}>
                <Link to="/services" onClick={handleMobileMenu} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>Services</Link>
            </li>
            <li className={parentMenu === 'infrastructure' ? ' current-menu-item' : ''} style={{ padding: '10px 0' }}>
                <Link to="/infrastructure" onClick={handleMobileMenu} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>Infrastructure</Link>
            </li>
            <li className={parentMenu === 'courses' ? 'dropdown current-menu-item' : 'dropdown'} style={{ display: 'block', padding: '10px 0' }}>
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    setIsCoursesDropdown(!isCoursesDropdown);
                    setIsPagesDropdown(false); // Close Pages dropdown
                }} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>
                    Courses
                    {isMobile && (
                        <i className={`fa ${isCoursesDropdown ? 'fa-angle-up' : 'fa-angle-down'} dropdown-icon`} style={{ marginLeft: '35px', color: '#fff', fontSize: '16px' }}></i>
                    )}
                </Link>
                <ul className="sub-menu" style={{ display: isCoursesDropdown ? 'block' : 'none', backgroundColor: '#3a2a1f', listStyle: 'none', padding: '0', margin: '0' }}>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses" onClick={handleMobileMenu} className={activeMenu === "/courses" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>All courses</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/acting" onClick={handleMobileMenu} className={activeMenu === "/acting" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Acting</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/direction" onClick={handleMobileMenu} className={activeMenu === "/direction" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Direction</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/cinemetography" onClick={handleMobileMenu} className={activeMenu === "/cinemetography" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Cinematography</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/influencer-creator" onClick={handleMobileMenu} className={activeMenu === "/influencer-creators" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Influencer Creators</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/photography" onClick={handleMobileMenu} className={activeMenu === "/photography" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Photography</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/video-editing" onClick={handleMobileMenu} className={activeMenu === "/videoediting" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Video Editing</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/script-writing" onClick={handleMobileMenu} className={activeMenu === "/scriptwriting" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Script writing</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/dubbing-and-voiceover" onClick={handleMobileMenu} className={activeMenu === "/dubbing-and-voiceover" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Dubbing and Voiceover</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/digital-marketing" onClick={handleMobileMenu} className={activeMenu === "/digitalmarketing" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Digital Marketing</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/personality-development" onClick={handleMobileMenu} className={activeMenu === "/personality-devlopment" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Personality Development</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/sound-engineering" onClick={handleMobileMenu} className={activeMenu === "/sound-engineering" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Sound Engineering</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/courses/visual-effects" onClick={handleMobileMenu} className={activeMenu === "/visual-effect" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Visual Effect</Link>
                    </li>
                </ul>
            </li>
            <li className={parentMenu === 'page' ? 'dropdown current-menu-item' : 'dropdown'} style={{ display: 'block', padding: '10px 0' }}>
                <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    setIsPagesDropdown(!isPagesDropdown);
                    setIsCoursesDropdown(false); // Close Courses dropdown
                }} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>
                    Pages
                    {isMobile && (
                        <i className={`fa ${isPagesDropdown ? 'fa-angle-up' : 'fa-angle-down'} dropdown-icon`} style={{ marginLeft: '35px', color: '#fff', fontSize: '16px' }}></i>
                    )}
                </Link>
                <ul className="sub-menu" style={{ display: isPagesDropdown ? 'block' : 'none', backgroundColor: '#3a2a1f', listStyle: 'none', padding: '0', margin: '0' }}>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/faculty" onClick={handleMobileMenu} className={activeMenu === "/team" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Faculty</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/brochure" onClick={handleMobileMenu} className={activeMenu === "/brochure" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Brochure</Link>
                    </li>
                    <li style={{ padding: '8px 0' }}>
                        <Link to="/testimonials" onClick={handleMobileMenu} className={activeMenu === "/testimonials" ? "active-menu" : ""} style={{ color: '#fff', display: 'block', padding: '10px 30px' }}>Testimonials</Link>
                    </li>
                </ul>
            </li>
            <li className={parentMenu === 'gallery' ? 'current-menu-item' : ''} style={{ padding: '10px 0' }}>
                <Link to="/gallery" onClick={handleMobileMenu} className={activeMenu === "/gallery" ? "active-menu" : ""} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>Gallery</Link>
            </li>
            <li className={parentMenu === 'blog' ? ' current-menu-item' : ''} style={{ padding: '10px 0' }}>
                <Link to="/blog" onClick={handleMobileMenu} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>Blog</Link>
            </li>
            <li className={parentMenu === 'contact' ? 'current-menu-item' : ''} style={{ padding: '10px 0' }}>
                <Link to="/contact" onClick={handleMobileMenu} className={activeMenu === "/contact" ? "active-menu" : ""} style={{ color: '#000', display: 'block', padding: '10px 15px', fontSize: '16px' }}>Contact</Link>
            </li>
        </React.Fragment>
    );
}

export default MenuItems;